module.exports = __webpack_public_path__ + "img/nav_2_22.1b4699eb.gif";